import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { useQuery } from '@apollo/client';
import { QUERY_GET_PROPERTY_TYPES } from 'common/queries/property';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const SelectPropertyInfo = ({ onChange, value }) => {
  const { t } = useTranslation();
  const { data, loading } = useQuery(QUERY_GET_PROPERTY_TYPES);
  const propertyTypes = data?.listPropertyTypes?.propertyTypes ?? [];
  return (
    <Select
      placeholder={t('cms:cms.properties.create.basic_information.apartment_name_placeholder')}
      loading={loading}
      onChange={apartMentType => {
        onChange(apartMentType, propertyTypes);
      }}
      value={value}
    >
      <For each="propertyType" of={propertyTypes}>
        <Option value={propertyType?.slug} key={propertyType?.id}>
          {propertyType?.name}
        </Option>
      </For>
    </Select>
  );
};

SelectPropertyInfo.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default SelectPropertyInfo;
